import { months } from "../account/store/store-bulk-import";

export function getMonthsArray() {
   const startYear = 2022;
   const endDate = new Date();
   const result = [];

   for (let year = startYear; year <= endDate.getFullYear(); year++) {
      for (let month of months) {
         const monthNumber = parseInt(month.value, 10);

         if (year === endDate.getFullYear() && monthNumber > (endDate.getMonth() + 1)) {
            break;
         }

         const formatted = `${month.label} ${year}`;
         const value = `${month.value}-${year}`;
         result.push({
            label: formatted,
            value: value
         });
      }
   }

   return result;
}

// export const dailyOverview = [
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
//    {
//       no: "#123431",
//       store: "Metropol",
//       generated_at: "05/09/2024 4:00 AM",
//       period: "Week 1, Sept 2024",
//       staf: "Griseld Gerveni"
//    },
// ]
export const dailtyOverviewColumns = [{
   label: 'No.',
   field: 'id',
   align: 'left'
}, {
   label: 'Period',
   field: 'period',
   align: 'left',
}, {
   label: 'Generated at',
   field: 'created_at',
   align: 'left',
}, {
   label: 'Actions',
   field: 'actions',
   align: 'left',
},];

export const monthlyOverview = [
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
   {
      no: "#123431",
      generated_at: "05/09/2024 4:00 AM",
      period: "Week 1, Sept 2024",
      staf: "Griseld Gerveni"
   },
];
export const monthlyOverviewColumns = [{
   label: 'No.',
   field: 'no',
   align: 'left'
},
{
   label: 'Period',
   field: 'period',
   align: 'left',
}, {
   label: 'Generated at',
   field: 'generated_at',
   align: 'left',
}, {
   label: 'Staf',
   field: 'staf',
   align: 'left',
}, {
   label: 'Actions',
   field: 'actions',
   align: 'left',
},];

export const inventoryTurnover = [
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },
   {
      no: "#123431",
      store_name: "Metropol",
      average_inventory: "5,000",
      cost: "25,000",
      turnover: "5.0",
      days: "73",
   },

];
export const inventoryTurnoverColumns = [{
   label: 'No.',
   field: 'no',
   align: 'left'
},
{
   label: 'Store Name',
   field: 'store_name',
   align: 'left'
}, {
   label: 'Average Inventory',
   field: 'average_inventory',
   align: 'center'
}, {
   label: 'Costs of Goods Sold',
   field: 'cost',
   align: 'center'
}, {
   label: 'Inventory Turnover',
   field: 'turnover',
   align: 'center'
}, {
   label: 'Days to Sell Inventory',
   field: 'days',
   align: 'center',
   cellComponent: ({ data }) => {
      return <span>{data}</span>
   }
},];

export const dailyOverviewModalCol = [{
   label: 'Day',
   field: 'day',
   align: 'center',
   editable: false
},
{
   label: 'Year 2023',
   field: 'initial_year',
   align: 'center',
   editable: true
}, {
   label: 'Year 2024',
   field: 'current_year',
   align: 'center',
   editable: true
}, {
   label: 'Year 2024',
   field: 'percentage',
   align: 'center',
      editable: false
   }, {
   label: 'Action',
   field: 'actions',
   align: 'center',
   editable: false
}];

export const dailyOverviewModalData = [
   {
      id: 1,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 56
   },
   {
      id: 2,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 65
   },
   {
      id: 3,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 44
   },
   {
      id: 4,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: -21
   },
   {
      id: 5,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 89
   },
   {
      id: 6,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: -23
   },
   {
      id: 7,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 12
   },
   {
      id: 8,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: -65
   },
   {
      id: 9,
      day: 1,
      initial_year: 0,
      current_year: 0,
      percentage: 16
   },

   {
      id: 10,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 11,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 12,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 13,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 14,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 15,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   }, {
      id: 16,
      day: 2,
      initial_year: 0,
      current_year: 0,
      percentage: -78
   },];


export const monthlyOverviewModalCol = [{
   label: 'Day',
   field: 'day',
   align: 'left',
   editable: false
}, {
   label: 'Daily Sales',
   field: 'daily_sales',
   align: 'left',
   editable: true
}, {
   label: '# of tickets',
   field: 'day',
   align: 'left',
   editable: true
}, {
   label: 'QTY',
   field: 'qty',
   align: 'left',
   editable: true
}, {
   label: 'PPT',
   field: 'ppt',
   align: 'left',
   editable: true
}, {
   label: 'VPT',
   field: 'vpt',
   align: 'left',
   editable: true
}, {
   label: 'PPP',
   field: 'ppp',
   align: 'left',
      editable: true
   }, {
      label: 'Action',
      field: 'actions',
      align: 'center',
      editable: false
   }];

export const monthlyOverviewModalData = [
   {
      id: 1,
      day: 1,
      daily_sales: 1500,
      qty: 300,
      ppt: 5,
      vpt: 10,
      ppp: 50
   },
   {
      id: 2,
      day: 2,
      daily_sales: 2000,
      qty: 250,
      ppt: 8,
      vpt: 12,
      ppp: 55
   },
   {
      id: 3,
      day: 3,
      daily_sales: 1800,
      qty: 280,
      ppt: 6.5,
      vpt: 11,
      ppp: 52
   },
   {
      id: 4,
      day: 4,
      daily_sales: 1600,
      qty: 320,
      ppt: 5.5,
      vpt: 10.5,
      ppp: 48
   },
   {
      id: 5,
      day: 5,
      daily_sales: 1900,
      qty: 310,
      ppt: 6,
      vpt: 11.2,
      ppp: 53
   },
   {
      id: 6,
      day: 6,
      daily_sales: 1700,
      qty: 275,
      ppt: 6.2,
      vpt: 10.8,
      ppp: 50
   },
   {
      id: 7,
      day: 7,
      daily_sales: 2100,
      qty: 340,
      ppt: 6.1,
      vpt: 11.3,
      ppp: 57
   },
   {
      id: 8,
      day: 8,
      daily_sales: 2200,
      qty: 360,
      ppt: 6.5,
      vpt: 11.8,
      ppp: 58
   },
   {
      id: 9,
      day: 9,
      daily_sales: 2400,
      qty: 390,
      ppt: 6.2,
      vpt: 12.0,
      ppp: 59
   },
   {
      id: 10,
      day: 10,
      daily_sales: 2300,
      qty: 350,
      ppt: 6.8,
      vpt: 11.9,
      ppp: 60
   },
   {
      id: 11,
      day: 11,
      daily_sales: 2000,
      qty: 300,
      ppt: 6,
      vpt: 10.5,
      ppp: 55
   },
   {
      id: 12,
      day: 12,
      daily_sales: 2150,
      qty: 315,
      ppt: 6.2,
      vpt: 11.2,
      ppp: 56
   }

];


